import React, { useState } from 'react';
import { useMyContext } from 'hooks'
import { Wrapper, NavItem, NavLeft } from './styles'

const SecondHeader = ({selectedTab, setSelectedTab}) => {
  const { t } = useMyContext();

  const handleNavItemClick = (e) => {
    const index = e.currentTarget.dataset.index;
    setSelectedTab(Number(index))
  }

  return (
    <Wrapper>
      <NavLeft>
        <NavItem index={0} isSelected={selectedTab === 0} onClick={handleNavItemClick}>{t['tabs:Rentability']}</NavItem>
        <NavItem index={1} isSelected={selectedTab === 1} onClick={handleNavItemClick}>{t['tabs:Return']}</NavItem>
        <NavItem index={2} isSelected={selectedTab === 2} onClick={handleNavItemClick}>{t['tabs:Underwater']}</NavItem>
      </NavLeft>
      {/* <NavRight style={{border: 'none'}}>
        <NavItem index={4}>Compartilhar</NavItem>
        <NavItem index={5}>Gerar QR Code</NavItem>
        <NavItem index={6}>Gerar PDF</NavItem>
      </NavRight> */}
    </Wrapper>
  );
}

export default SecondHeader;